import styled from 'styled-components';

// @ts-ignore
import Carousel from '@r1-frontend/ui-react/deprecated/carousel';

import { breakPoints } from '~/src/features/domru-bonus/styled';

export const BonusCarousel = styled(Carousel)`
    & > div {
        padding-bottom: 0;
        & > div {
            @media (max-width: ${breakPoints.sDesktop}) {
                width: 75%;
            }
            @media (max-width: ${breakPoints.tablet}) {
                width: 100%;
            }
            @media (max-width: ${breakPoints.mobile}) {
                touch-action: auto;
                pointer-events: initial;
            }
        }
    }
`;
